import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '@app/core/services/app.service';

@Pipe({
  name: 'filterCondominio'
})
export class FilterCondominioPipe implements PipeTransform {

  constructor(private app: AppService) { }

  transform(items: any[], search: string): any {
    if (!items) {
      return [];
    }

    if (!search) {
      return items;
    }

    search = this.app.normalizeText(`${search}`);

    return items.filter(item => {
      const itemBuscado: string = this.app.normalizeText(`${item.nome}`);
      if (itemBuscado.indexOf(search) !== -1) {
        return item;
      }
    });
  }

}
